module.exports = __webpack_public_path__ + "static/media/va-256x256.4b4289b0.png";